import React, { useEffect } from 'react';
import Gtm from './GTM';
import FBPixel from './FBPixel';
import Bayonet from './Bayonet';

function Analytics() {
  return (
    <>
      <Gtm />
      <FBPixel />
    </>
  );
}

export default Analytics;
